import React from 'react';
import { EyeIcon, MessageCircleIcon, ZapIcon, CrosshairIcon } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    icon: <EyeIcon className="w-8 h-8 text-gold" data-id="element-205" />,
    title: 'El Primer Contacto',
    desc: 'Cómo romper el hielo sin parecer desesperado o raro.'
  }, {
    icon: <ZapIcon className="w-8 h-8 text-gold" data-id="element-206" />,
    title: 'Tensión Sexual Elegante',
    desc: 'Aprende a proyectar deseo sin decir una sola palabra subida de tono.'
  }, {
    icon: <CrosshairIcon className="w-8 h-8 text-gold" data-id="element-207" />,
    title: 'Lenguaje Corporal de Alfa',
    desc: 'La postura exacta que comunica alto valor instantáneo.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8 text-gold" data-id="element-208" />,
    title: 'Dominio de Conversación',
    desc: 'Qué decir después del "Hola" para que ella no pierda el interés.'
  }, {
    icon: <ZapIcon className="w-8 h-8 text-gold" data-id="element-209" />,
    title: 'El Fin de la "Friendzone"',
    desc: 'Cómo posicionarte como un hombre de interés desde el segundo 1.'
  }];
  const scrollToTestimonials = () => {
    document.getElementById('testimonials-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 bg-surface-card relative border-y border-surface-border" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="text-center mb-10" data-id="element-212">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-213">
            La ciencia detrás de los{' '}
            <span className="text-gold italic" data-id="element-214">Trucos</span> Sociales
          </h2>
          <p className="font-body text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-215">
            El carisma no se nace, se construye. Consta de 17{' '}
            <span className="text-gold italic" data-id="element-216">trucos</span> mecánicos y
            psicológicos que transforman tu energía y cómo te percibe el mundo.
            No tienes que cambiar tu personalidad, solo ajustar ciertos
            patrones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-217">
          {benefits.map((benefit, index) => <div key={index} className="bg-surface-deepest p-8 rounded-2xl border border-surface-border hover:border-gold/40 transition-all duration-300 group" data-id="element-218">
              <div className="mb-6 bg-surface-elevated w-16 h-16 rounded-xl flex items-center justify-center border border-gold/20 group-hover:scale-110 transition-transform duration-300" data-id="element-219">
                {benefit.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-3" data-id="element-220">
                {benefit.title}
              </h3>
              <p className="font-body text-sm text-gray-400 leading-relaxed" data-id="element-221">
                {benefit.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-222">
          <button onClick={scrollToTestimonials} className="px-10 py-5 bg-red-600 hover:bg-red-700 text-white font-body font-bold text-lg rounded-xl transition-all duration-300 animate-heartbeat animate-pulse-red shadow-lg shadow-red-600/20" data-id="element-223">
            SÍ, QUIERO SER UN HOMBRE MAGNÉTICO →
          </button>
        </div>
      </div>
    </section>;
}